"use client";

import React from "react";
import { Dialog, DialogContent, DialogTrigger } from "@/components/ui/dialog";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const galleryImages = [{
  id: 1,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1602682/img/sunlight_wooden_table_coffee.png",
  alt: "Morning light catching the texture of our hand-planed oak tables",
  aspect: "aspect-[4/5]"
}, {
  id: 2,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1602682/img/flaky_croissant_close_up.png",
  alt: "The precise, geometric layers of our signature artisanal pastry",
  aspect: "aspect-square"
}, {
  id: 3,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1602682/img/sage_green_velvet_chairs_cafe.png",
  alt: "Minimalist seating against raw concrete walls in our main hall",
  aspect: "aspect-[4/5]"
}, {
  id: 4,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1602682/img/artisanal_coffee_pouring.png",
  alt: "The ritual of the pour, reflecting modernity in every detail",
  aspect: "aspect-square"
}, {
  id: 5,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1602682/img/espresso_wood_interior_details.png",
  alt: "Shadow and light playing across dark Nordic slate and wood textures",
  aspect: "aspect-[4/5]"
}, {
  id: 6,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1602682/img/barista_crafting_latte_art.png",
  alt: "The focused craftsmanship that defines the NordicBite experience",
  aspect: "aspect-square"
}];
export default function TheCreedExperience() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: galleryRef,
    isVisible: isGalleryVisible
  } = useRevealOnScroll({
    threshold: 0.05
  });
  return <section data-section-id="73019" id="the-dining-atmosphere" className="dark bg-background py-24 sm:py-32 overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div ref={headerRef} className={`max-w-3xl mx-auto text-center mb-16 md:mb-24 transition-all duration-1000 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <h2 className="text-4xl md:text-6xl font-serif text-foreground mb-6 tracking-tighter italic">
            The Dining Atmosphere
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground font-sans leading-relaxed tracking-normal">
            A masterclass in Hygge reimagined. Our space is a curated dialogue between 
            raw concrete, warm oak, and the soft glow of candlelight—an immersive 
            sanctuary where modernity meets the silence of the North.
          </p>
        </div>

        <div ref={galleryRef} className={`columns-1 sm:columns-2 lg:columns-3 gap-6 space-y-6 transition-all duration-1000 delay-200 ease-out ${isGalleryVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {galleryImages.map((img, i) => <div key={img.id} data-index={i} className="break-inside-avoid">
              <Dialog>
                <DialogTrigger asChild>
                  <button className="w-full block relative group overflow-hidden border border-border/20 hover:border-primary/40 transition-colors duration-700 cursor-zoom-in focus:outline-none focus-visible:ring-1 focus-visible:ring-primary" aria-label={`View larger image of ${img.alt}`}>
                    <div className="absolute inset-0 bg-background/20 group-hover:bg-transparent transition-colors duration-700 z-10 pointer-events-none" />
                    <img src={img.src} alt={img.alt} loading="lazy" className={`w-full object-cover ${img.aspect} opacity-70 group-hover:opacity-100 transition-all duration-1000 ease-out group-hover:scale-105 grayscale-[30%] group-hover:grayscale-0`} />
                    <div className="absolute bottom-4 left-4 z-20 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                      <span className="text-[10px] font-mono uppercase tracking-[0.2em] text-foreground bg-background/60 backdrop-blur-sm px-2 py-1">
                        Nordic Detail
                      </span>
                    </div>
                  </button>
                </DialogTrigger>
                <DialogContent className="max-w-5xl w-[95vw] bg-transparent border-none shadow-none p-0 flex justify-center items-center" showCloseButton={true}>
                  <div className="relative w-full flex justify-center">
                    <img src={img.src} alt={img.alt} className="max-h-[85vh] w-auto object-contain shadow-2xl border border-border/10" />
                  </div>
                </DialogContent>
              </Dialog>
            </div>)}
        </div>
      </div>
    </section>;
}